import { Pipe, PipeTransform } from '@angular/core';
import { UserDetail, UserInfo } from '@ca/core/models';

@Pipe({
    name: 'fullName',
})
export class FullNamePipe implements PipeTransform {
    transform(userInfo?: UserInfo | UserDetail): string {
        if (
            userInfo == null ||
            ((userInfo.firstName == null || userInfo.firstName.trim() === '') && (userInfo.lastName == null || userInfo.lastName.trim() === ''))
        ) {
            return '';
        } else if (userInfo.firstName && (userInfo.lastName == null || userInfo.lastName.trim() === '')) {
            return `${userInfo.firstName}`;
        } else if ((userInfo.firstName == null || userInfo.firstName.trim() === '') && userInfo.lastName) {
            return `${userInfo.lastName}`;
        } else {
            return `${userInfo.firstName.trim()} ${userInfo.lastName.trim()}`;
        }
    }
}
